import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import SubstratesApiService from './_services/substrates.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    substrates: [],
    substratesTotalCount: 0,
  },
  mutations: {
    [MutationTypes.SET_SUBSTRATES](state, payload) {
      state.substrates = payload;
    },
    [MutationTypes.SET_SUBSTRATES_TOTAL_COUNT](state, payload) {
      state.substratesTotalCount = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_SUBSTRATES](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      const { items, totalCount } = await SubstratesApiService.getSubstrates({ suffix, ...rest });

      commit(MutationTypes.SET_SUBSTRATES, items);
      commit(MutationTypes.SET_SUBSTRATES_TOTAL_COUNT, totalCount);
    },
  },
};
